import ERC721AbstractFacade from './ERC721AbstractFacade'
import { Benefit, ClaimableBenefit } from 'components/Benefits/Benefits.types'
import { ERC721ABI } from 'core/constants/ERC721'
import { BaseAssetType } from 'core/logic/asset/asset.types'
import { i18n } from 'translate/i18n'

export default class ERC721LoyaltyFacade extends ERC721AbstractFacade<Contract.ERC721> {
  getContractInstance(): Contract.ERC721 {
    return new this.web3ForRead.eth.Contract(
      ERC721ABI,
      this.contractAddress
    ) as unknown as Contract.ERC721
  }
  async getBenefits(asset: BaseAssetType) {
    const attributeDetails = asset.attributes_extension!.reduce(
      (r, attr) => ({
        ...r,
        [attr.trait_type]: attr,
      }),
      {} as {
        [k: string]: NonNullable<typeof asset.attributes_extension>[number]
      }
    )
    const attributes = await Promise.all([
      this.nftContractForRead.methods.attributes(String(asset.tokenId)).call(),
    ])

    const benefits: (ClaimableBenefit & {
      benefitKey: string
    })[] = []

    for (let benefitMap of attributes) {
      for (let [attributeName, attributeAmount] of benefitMap) {
        const existingBenefit = benefits.find(
          (b) => b.benefitKey === attributeName
        )
        if (!existingBenefit)
          benefits.push({
            benefitKey: attributeName,
            available: Number(attributeAmount),
            description:
              attributeDetails[attributeName][i18n.language as LanguageCodes]
                .description,
            title:
              attributeDetails[attributeName][i18n.language as LanguageCodes]
                .title,
            details:
              attributeDetails[attributeName][i18n.language as LanguageCodes]
                .details_html,
            assetId: asset.id,
            code: attributeName,
            tokenId: asset.tokenId!,
            coverImg: attributeDetails[attributeName].cover,
          })
        else existingBenefit.available += Number(attributeAmount)
      }
    }

    return benefits as Benefit[]
  }
}
